import { saveUtilityCache } from '../../../utils/utilityAppStorage';
import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';

const STORAGE_KEY = 'libroGastosData';

export function useGastos() {
  const [gastos, setGastos] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      console.error('Error leyendo gastos', e);
      return [];
    }
  });

  useEffect(() => {
    try {
      saveUtilityCache(STORAGE_KEY, gastos);
    } catch (e) {
      console.error('Error guardando gastos', e);
    }
  }, [gastos]);

  const agregarGasto = (data) => {
    setGastos(prev => [
      ...prev,
      {
        id: uuid(),
        ...data,
        estado: 'ACTIVO', // ACTIVO | ANULADO
        createdAt: new Date().toISOString(),
        updatedAt: null,
        motivoAnulacion: null
      }
    ]);
  };

  const editarGasto = (id, data) => {
    setGastos(prev =>
      prev.map(g =>
        g.id === id
          ? { ...g, ...data, updatedAt: new Date().toISOString() }
          : g
      )
    );
  };

  const anularGasto = (id, motivo) => {
    setGastos(prev =>
      prev.map(g =>
        g.id === id
          ? {
              ...g,
              estado: 'ANULADO',
              motivoAnulacion: motivo,
              updatedAt: new Date().toISOString()
            }
          : g
      )
    );
  };

  return { gastos, agregarGasto, editarGasto, anularGasto };
}
